import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import CenterPanel from './centerPanel';
import CenterPanelReadOnly from './centerPanelReadOnly';
import RightPanelTop from './rightPanelTop';
import RightPanelBottom from './rightPanelBottom';
import PopupHeader from '../../popupHeader';
import Modal from '../../../shared/modal/content';

export default function OrgUnitBeforeCallForWaitingArea(props) {
  const beforeCallsFormForWA = useSelector((state) => state.organisationsReducer.beforeCallsFormForWA);

  const rightPanel = (
    <RightPanelTop
      selectedOrgUnit={props.selectedOrgUnit}
      beforeCallsFormForWA={beforeCallsFormForWA}
      updateOrView={props.updateOrView}
    />
  );
  const centerPanel =
    props.updateOrView == 'update' ? (
      <CenterPanel beforeCallsFormForWA={beforeCallsFormForWA} selectedOrgUnit={props.selectedOrgUnit} />
    ) : (
      <CenterPanelReadOnly beforeCallsFormForWA={beforeCallsFormForWA} selectedOrgUnit={props.selectedOrgUnit} />
    );

  return (
    <Modal show={true} hideWhenClickAway={false}>
      <PopupHeader
        title={APP.LANGUAGE.OrgUnitDefaultBeforeCallsForWA.TitleUpdateAndView}
        subtitle={props.selectedOrgUnit ? props.selectedOrgUnit.name : ''}
        helpLink={APP.EXTERNAL_LINKS.OrgUnit.HelpOrgUnitPleaseRead}
      />
      <div className="content before-calls-important-info-modal">
        <div
          className={
            props.updateOrView == 'update'
              ? 'main-ui-container before-calls-important-info-modal'
              : 'main-ui-container before-calls-important-info-modal-read-only'
          }
        >
          <div id="righthandfloatingpanel">
            <div className="right ui rail">
              <div className="ui sticky">{rightPanel}</div>
              <RightPanelBottom updateOrView={props.updateOrView} />
            </div>
            {centerPanel}
            <div className="bottom-rail-with-left-and-right-content mrtxl">
              {rightPanel}
              <RightPanelBottom updateOrView={props.updateOrView} />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
